const lang = document.documentElement.lang;
const labels = {
  prev_de: 'Zurück blättern',
  prev_en: 'move backwards',
  next_de: 'Weiter blättern',
  next_en: 'move forwards',
  close_de: 'Schließen (Esc)',
  close_en: 'Close (Esc)',
  zoom_de: 'Vergrößern/Verkleinern',
  zoom_en: 'Zoom in/out',
};

// eslint-disable-next-line import/no-anonymous-default-export
export default `
<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="pswp__bg"></div>
  <div class="pswp_imagetitle_text pswp--is-clone">
    <p><span class="pswp_imagetitle"></span></p>
  </div>
  <div class="pswp__caption pswp--is-clone">
    <div class="pswp__captiontext"></div>
    <div class="pswp__copyright"></div>
  </div>
  <div class="pswp__scroll-wrap">
    <div class="pswp__container">
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
    </div>
    <div class="pswp__ui pswp__ui--hidden">
      <div class="pswp__top-bar">
        <div class="pswp_imagetitle_text">
          <p><span id="pswp_imagetitle"></span></p>
        </div>
        <button class="pswp__button pswp__button--close icon-plus" title="${
          labels[`close_${lang}`]
        }"  type="button">
            <span class="sr-only">${labels[`close_${lang}`]}</span>
        </button>
        <button class="pswp__button pswp__button--zoom icon-zoom-in" title="${
          labels[`zoom_${lang}`]
        }"  type="button">
            <span class="sr-only">${labels[`zoom_${lang}`]}</span>
        </button>
        <button class="pswp__button pswp__button--zoom icon-zoom-out" title="${
          labels[`zoom_${lang}`]
        }"  type="button">
            <span class="sr-only">${labels[`zoom_${lang}`]}</span>
        </button>
        <div class="pswp__preloader">
          <div class="pswp__preloader__icn">
            <div class="pswp__preloader__cut">
              <div class="pswp__preloader__donut"></div>
            </div>
          </div>
        </div>
      </div>
      <button class="pswp__button pswp__button--arrow--left icon-arrow-left" title="${
        labels[`prev_${lang}`]
      }"  type="button">
        <span class="sr-only">${labels[`prev_${lang}`]}</span>
      </button>
      <button class="pswp__button pswp__button--arrow--right icon-arrow-right" title="${
        labels[`next_${lang}`]
      }"  type="button">
        <span class="sr-only">${labels[`next_${lang}`]}</span>
      </button>
      <div class="pswp__caption">
        <div id="pswp__captiontext"></div>
        <div id="pswp__copyright" class="pswp__copyright"></div>
      </div>
      <div class="pswp__counter"></div>
    </div>
  </div>
</div>
`;
